import { render, staticRenderFns } from "./DeviceTechnicalFeatures.vue?vue&type=template&id=2aa44a84&scoped=true"
import script from "./DeviceTechnicalFeatures.vue?vue&type=script&lang=js"
export * from "./DeviceTechnicalFeatures.vue?vue&type=script&lang=js"
import style0 from "./DeviceTechnicalFeatures.vue?vue&type=style&index=0&id=2aa44a84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa44a84",
  null
  
)

export default component.exports